import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Tabs,
  Tab,
} from '@mui/material';

import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import SendIcon from '@mui/icons-material/Send';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import CloseIcon from '@mui/icons-material/Close';

import TopNav from './Navbar';
import LeftNavbar from './LeftNav';
import Breadcrumb from './BreadCrump';

const getStatusChip = (status) => {
  switch (status) {
    case 'Answered':
      return <Chip icon={<DoneAllIcon />} label="Answered" color="success" size="small" />;
    case 'Open':
      return <Chip icon={<QuestionAnswerIcon />} label="Open" color="warning" size="small" />;
    case 'Closed':
      return <Chip icon={<CloseIcon />} label="Closed" color="error" size="small" />;
    default:
      return <Chip label="Unknown" size="small" />;
  }
};

const PostQuery = () => {
  const [tabValue, setTabValue] = useState(0);
  const [queries, setQueries] = useState([]);
  const [courses, setCourses] = useState([]);
  const [newQuery, setNewQuery] = useState({
    courseTitle: '',
    customTitle: '',
    content: '',
  });

  useEffect(() => {
    axios
      .get('http://196.216.9.34:5021/api/courses')
      .then((res) => setCourses(res.data))
      .catch((err) => console.error('Failed to fetch courses:', err));

    axios
      .get('http://196.216.9.34:5021/api/queries')
      .then((res) => setQueries(res.data))
      .catch((err) => console.error('Failed to fetch queries:', err));
  }, []);

  const handlePost = () => {
    const title =
      newQuery.courseTitle === 'other' ? newQuery.customTitle : newQuery.courseTitle;

    if (!title || !newQuery.content) return;

    const matchedCourse = courses.find((c) => c.title === newQuery.courseTitle);
    const course_id = matchedCourse ? matchedCourse.id : null;

    const payload = {
      title,
      content: newQuery.content,
      date: new Date().toISOString().split('T')[0],
      status: 'Open',
      course_id,
    };

    axios
      .post('http://196.216.9.34:5021/api/queries', payload)
      .then((res) => {
        setQueries([res.data.query, ...queries]);
        setNewQuery({ courseTitle: '', customTitle: '', content: '' });
        setTabValue(1); // Switch to "Previous Queries" tab after posting
      })
      .catch((err) => console.error('Failed to post query:', err));
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <LeftNavbar />
      <Box sx={{ flexGrow: 1, ml: { lg: '240px' } }}>
        <TopNav />
        <Box sx={{ p: 10, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          <Breadcrumb currentPage="Post Query" />

          <Typography variant="h4" fontWeight="bold" sx={{ mb: 4, color: '#ff6600' }}>
            <ChatBubbleIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Post Query
          </Typography>

          {/* Tabs */}
          <Tabs
            value={tabValue}
            onChange={(e, newValue) => setTabValue(newValue)}
            sx={{ mb: 3 }}
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab label="Create New Query" />
            <Tab label="View Open Queries" />
            <Tab label="View Closed Queries" />
          </Tabs>

          {/* Tab Panel: Ask Question */}
          {tabValue === 0 && (
            <Card sx={{ mb: 4, boxShadow: 2 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Post A New Query
                </Typography>
                <Grid container spacing={2} direction="column">
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>Select Course Title</InputLabel>
                      <Select
                        value={newQuery.courseTitle}
                        label="Select Course Title"
                        onChange={(e) =>
                          setNewQuery({ ...newQuery, courseTitle: e.target.value })
                        }
                      >
                        {courses.map((course) => (
                          <MenuItem key={course.id} value={course.title}>
                            {course.title}
                          </MenuItem>
                        ))}
                        <MenuItem value="other">Other</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {newQuery.courseTitle === 'other' && (
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Custom Title"
                        value={newQuery.customTitle}
                        onChange={(e) =>
                          setNewQuery({ ...newQuery, customTitle: e.target.value })
                        }
                      />
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      minRows={4}
                      label="Your Question"
                      value={newQuery.content}
                      onChange={(e) =>
                        setNewQuery({ ...newQuery, content: e.target.value })
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      onClick={handlePost}
                      variant="contained"
                      startIcon={<SendIcon />}
                      sx={{ bgcolor: '#ff6600', '&:hover': { bgcolor: '#e65c00' } }}
                    >
                      Post Query
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          )}

          {/* Tab Panel: Previous Queries */}
          {tabValue === 1 && (
            <>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Your Queries
              </Typography>
              <Paper elevation={3}>
                <Table>
                  <TableHead sx={{ backgroundColor: '#ff6600' }}>
                    <TableRow>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Title</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Question</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Date</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {queries.map((query) => (
                      <TableRow key={query.id}>
                        <TableCell>{query.title}</TableCell>
                        <TableCell>{query.content}</TableCell>
                        <TableCell>{query.date}</TableCell>
                        <TableCell>{getStatusChip(query.status)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </>
          )}

{tabValue === 2 && (
            <>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Your Queries
              </Typography>
              <Paper elevation={3}>
                <Table>
                  <TableHead sx={{ backgroundColor: '#ff6600' }}>
                    <TableRow>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Title</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Question</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Date</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {queries.map((query) => (
                      <TableRow key={query.id}>
                        <TableCell>{query.title}</TableCell>
                        <TableCell>{query.content}</TableCell>
                        <TableCell>{query.date}</TableCell>
                        <TableCell>{getStatusChip(query.status)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default PostQuery;
